import api from '../../ApiConfig';
import { Apis } from '../../config';
const getCategories = async () => {
    try {
        var token =  sessionStorage.getItem('userToken');
        let result = await api.get(Apis.GetCategories, {
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
        
    } catch (error) {
        
            // Alerts.alertMessage(error.response.data, "Sorry !", "danger");
       
        return error;
    }
};
const getCategoriesWithTopLevel = async () => {
    try {
        var token =  sessionStorage.getItem('userToken');
        let result = await api.get(Apis.GetCategoriesWithTopLevel, {
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
        
    } catch (error) {
        
            // Alerts.alertMessage(error.response.data, "Sorry !", "danger");
       
        return error;
    }
};

const createCategory = async (data) => {
    try {
        var token =  sessionStorage.getItem('userToken');
        let result = await api.post(Apis.CreateCategory, data, {
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
        
    } catch (error) {
    
    //  Alerts.alertMessage(error.response.data, "Sorry !", "danger");
       
        return error;
    }
};

const deleteCategory = async (id) => {
    try {
        var token =  sessionStorage.getItem('userToken');
        let result = await api.get(Apis.DeleteCategory + id, {
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
        
    } catch (error) {
        return error;
    }
}


const getSingleCategory = async (id) => {
    try {
        var token =  sessionStorage.getItem('userToken');
        let result = await api.get(Apis.GetSingleCategory + id, {
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
        
    } catch (error) {
        return error;
    }
}


const updateCategory = async (id, data) => {
    try {
        var token =  sessionStorage.getItem('userToken');
        let result = await api.post(Apis.UpdateCategory + id, data,{
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
        
    } catch (error) {
        return error;
    }
}

const removeCategoryThumb = async (id) => {
    try {
        var token =  sessionStorage.getItem('userToken');
        let result = await api.get(Apis.RemoveCategoryThumb + id,{
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
        
    } catch (error) {
        return error;
    }
}

const addNewCategoryThumbnail = async (id, data) => {
    try {
        var token =  sessionStorage.getItem('userToken');
        let result = await api.post(Apis.AddNewCategoryThumb + id, data,{
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
        
    } catch (error) {
        return error;
    }
}



const exportedObject = {
    getCategories,
    createCategory,
    deleteCategory,
    getSingleCategory,
    updateCategory,
    removeCategoryThumb,
    addNewCategoryThumbnail,
    getCategoriesWithTopLevel
};
export default exportedObject;